import { useAccount } from "./AccountProvider";
import styles from "./Toast.module.css";

/** On the browser's top layer, so a message stays readable above an open form ("Save and add another"). */
const raise = (el: HTMLDivElement | null) => { try { el?.showPopover(); } catch { /* older browser: it shows in the page */ } };

/** A short confirmation that disappears by itself; some offer one action, like Undo. */
export function Toast() {
  const { toast, dismissToast } = useAccount();
  return (
    <div aria-live="polite">
      {toast && (
        <div className={styles.toast} role="status" key={toast.id} popover="manual" ref={raise}>
          <span>{toast.message}</span>
          {toast.action && (
            <button type="button" className={styles.action} onClick={() => { dismissToast(); toast.action?.run(); }}>{toast.action.label}</button>
          )}
        </div>
      )}
    </div>
  );
}
